<template>
  <div class="">
    <menu-component
      :menu="menu"
      @click="$emit('click')"
    />
    <ul class="list-unstyled mb-0 p-3 border-bottom">
      <li
        class="menu-item menu-item-type-post_type menu-item-object-page menu-item-home"
      >
        <contact-block
          :text-align-right="false"
          :phone="phoneBlock.phone"
          :time="phoneBlock.time"
          :icon="phoneBlock.icon"
          :phone_link="phoneBlock.phone_link"
          :time_link="phoneBlock.time_link"
        />
      </li>
    </ul>
    <div class="p-3">
      <div class="py-2">{{strings.commonApp && strings.commonApp.switch_lang}}</div>
      <switch-lang
        :langs="langs"
        :lang="lang"
      />
    </div>
  </div>
</template>
<script>
import { mapState } from 'vuex';
import menuComponent from '@/components/menuComponent.vue';
import switchLang from '@/components/switchLang.vue';
import LogService from '@/services/LogService';
import ContactBlock from '@/components/contact/contact-block.vue';

export default {
  props: {
    menu: {
      type: Array,
      default: () => [],
    },
    phoneBlock: Object,
  },
  components: {
    menuComponent,
    ContactBlock,
    switchLang,
  },
  computed: {
    ...mapState(['strings', 'langs', 'lang']),
    currentLang() {
      // compute current lang by url
      const current = this.$route.params.lang ? this.$route.params.lang.toLowerCase() : 'en';
      LogService.log('currentLang', current, this.langs);
      return this.langs.filter((el) => el.lang === current)[0];
      // return this.$_.filter(this.langs, { 'lang': current})[0]
    },
    langsFiltered() {
      // filter other langs except current
      const current = this.$route.params.lang ? this.$route.params.lang.toLowerCase() : 'en';
      return this.langs.filter((el) => el.lang !== current);
      // return this.$_.reject(this.langs, { 'lang': current})
    },
  },
  watch: {
    menu() {
      LogService.log('menu appDrawer', this.menu);
    },
  },
};
</script>
